'use client';

import { memo } from 'react';
import { PoolCard } from '@/components/pool/PoolCard';
import { EmptyState } from '@/components/common/EmptyState';
import { Database } from 'lucide-react';
import type { Pool } from '@/lib/types/auction';

interface PoolGridProps {
  pools: Pool[];
  emptyMessage: string;
  emptyStateCss?: string;
  onSelectPool?: (pool: Pool) => void;
  onPoolClick?: (poolId: string) => void;
  selectedPoolId?: string;
  actionButtonLabel?: string;
  onAction?: (pool: Pool) => void;
}

export const PoolGrid = memo(function PoolGrid({
  pools,
  onSelectPool,
  onPoolClick,
  selectedPoolId,
  actionButtonLabel,
  onAction,
  emptyStateCss,
  emptyMessage = 'No pools available',
}: PoolGridProps) {
  if (pools.length === 0) {
    return (
      <EmptyState
        title="No Pools Available"
        message={emptyMessage}
        icon={<Database className="h-12 w-12" />}
        className={emptyStateCss}
      />
    );
  }

  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {pools.map((pool) => (
        <PoolCard
          key={pool.id}
          pool={pool}
          isSelected={selectedPoolId === pool.id}
          onClick={
            onPoolClick
              ? () => onPoolClick(pool.id)
              : onSelectPool
                ? () => onSelectPool(pool)
                : undefined
          }
          actionButtonLabel={actionButtonLabel}
          onAction={() => onAction?.(pool)}
        />
      ))}
    </div>
  );
});
